import Axios, { AxiosRequestConfig } from "axios";
import { useCallback, useState } from "react";

interface IAxiosProps {
  url: string;
  config?: AxiosRequestConfig;
}

interface IAxios<T> {
  loading: boolean;
  data: T | null;
  error: Error | null;
}

/**
 * Creates an axios query and returns it, run it whenever you want.
 * @param { url, config }
 * @param deps
 */
export const useAxiosLazyQuery = <T>(
  { url, config }: IAxiosProps,
  deps: React.DependencyList = []
): [() => Promise<IAxios<T>>, IAxios<T>] => {
  const [response, setResponse] = useState<IAxios<T>>({
    loading: false,
    data: null,
    error: null,
  });

  const query = useCallback(
    async (): Promise<IAxios<T>> => {
      setResponse({ loading: true, data: null, error: null });

      try {
        const { data } = await Axios.get<T>(url, config);
        const res = { loading: false, data, error: null };
        setResponse(res);

        return res;
      } catch (error) {
        const err = { loading: false, data: null, error };
        setResponse(err);

        return err;
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    deps
  );

  return [query, response];
};
